<template>
    <div id="app">

        <router-view :key="this.$route.params.id"/>

    </div>
</template>


<script>
export default {
  name: 'App',
  data() {
    return {}
  },



  
}
</script>


<style src="@vueform/multiselect/themes/default.css"></style>
<style>
  @import "./css/segeo_font_import.css";
  @import "./css/colors.css";
  @import "./css/sizing.css";
  @import "./css/text.css";
  @import "./css/tooltip.css";
</style>